module.exports = __webpack_public_path__ + "/static/assets/23ac5f851c9cc16ac55b6ca38526330a.png";